export const API_BASE_URL = 'https://admin.brainershub.in/api';
export const BASE_URL = 'https://admin.brainershub.in';

// export const API_BASE_URL = 'http://localhost/brainershub/api';
// export const BASE_URL = 'http://localhost/brainershub';

export const razorpay_key = 'rzp_live_jJQPZ05uCdNgNS';
export const institute_id = '6';
// export const razorpay_key = 'rzp_test_Rf5wtIGvhjhFUi';
